export type AuthFailureClass =
  | "unauthenticated"
  | "forbidden"
  | "server"
  | "other";

const SESSION_PROBE = /\/auth\/(check-status|renew|session)(\?|$)/;

export function classifyAuthFailure(status: number | undefined): AuthFailureClass {
  if (status === 401) {
    return "unauthenticated";
  }
  if (status === 403) {
    return "forbidden";
  }
  if (status != null && status >= 500) {
    return "server";
  }
  return "other";
}

/**
 * 401 de un endpoint de datos no invalida la sesión.
 * Solo un probe explícito de sesión (/auth/check-status|renew|session) puede
 * limpiarla. 403 y 5xx nunca limpian.
 */
export function shouldDestroySession(
  status: number | undefined,
  url = "",
): boolean {
  if (status !== 401) {
    return false;
  }
  return SESSION_PROBE.test(url);
}
